import type { Card } from "@stackje/common/config";
import { parseHeroCard } from "./heroCard";
import { parseTextCard } from "./textCard";
import { parseLinkCard } from "./linkCard";
import { parseFeatureCard } from "./featureCard";
import { parseFaqCard } from "./faqCard";
import { parseImageCard } from "./imageCard";
import { parseWhatsapp1Card, parseWhatsapp2Card } from "./whatsappCard";
import { parseTippingCard } from "./tippingCard";

type ParserFunction = (formData: FormData) => Card;

export const cardParserRegistry: Record<string, ParserFunction> = {
  hero1: parseHeroCard,
  hero2: parseHeroCard,
  hero3: parseHeroCard,
  hero4: parseHeroCard,
  hero5: parseHeroCard,
  text1: parseTextCard,
  link1: parseLinkCard,
  link2: parseLinkCard,
  link3: parseLinkCard,
  link4: parseLinkCard,
  link5: parseLinkCard,
  link6: parseLinkCard,
  feature1: parseFeatureCard,
  feature2: parseFeatureCard,
  faq1: parseFaqCard,
  faq2: parseFaqCard,
  image1: parseImageCard,
  image2: parseImageCard,
  image3: parseImageCard,
  image4: parseImageCard,
  image5: parseImageCard,
  whatsapp1: parseWhatsapp1Card,
  whatsapp2: parseWhatsapp2Card,
  tipping1: parseTippingCard,
  tipping2: parseTippingCard,
};
